import { InjectionToken } from '@angular/core';
import { Auth } from 'firebase/auth';
/** SDK instance shared by social login; no Angular-major-specific Firebase wrapper. */
export const FIREBASE_AUTH = new InjectionToken<Auth>('SCREENLEADS_FIREBASE_AUTH');
